import React from "react";
import styled from "styled-components";

const DrugInformation = () => {
  return (
    <Container>
      <InnerContainer>
        <FlexContainer>
          <p>
            <strong>PFS</strong> - pre-filled syringe.{" "}
            <sup>
              <small>+</small>
            </sup>
            29 vs 27-gauge needle of the reference product, Stelara
            <sup>
              <small>®1,3</small>
            </sup>
            ;{" "}
            <sup>
              <small>++</small>
            </sup>
            Plunger stopper made of bromobutyl rubber. <sup>†</sup>patients ≥40 kg
            <br />
            <strong>1.</strong> Uzpruvo
            <sup>
              <small>®</small>
            </sup>{" "}
            SmPC <strong>2.</strong> Feldman SR et al. Expert Opin Biol Ther.
            2023;23(3):253-60. DOI: 10.1080/14712598.2023.2235263;{" "}
            <strong>3.</strong> Stelara
            <sup>
              <small>®</small>
            </sup>{" "}
            PI (Aug. 2022).
          </p>
        </FlexContainer>
        <p>
          <strong>
            UZPRUVO
            <sup>
              <small>®</small>
            </sup>
            ▼ 45 mg & 90 mg Solution for Injection in Pre-filled Syringe.
          </strong>
          <br />
          <strong>
            UZPRUVO
            <sup>
              <small>®</small>
            </sup>
            ▼ 130 mg Concentrate for Solution for Infusion.
          </strong>
        </p>
        <p>
          <strong>
            ▼ This medicinal product is subject to additional monitoring. This
            will allow quick identification of new safety information.
            Healthcare professionals are asked to report any suspected adverse
            reactions. Reporting suspected adverse reactions after authorisation
            of the medicinal product is important. It allows continued
            monitoring of the benefit/risk balance of the medicinal product.
            Healthcare professionals are asked to report any suspected adverse
            reactions to HPRA Pharmacovigilance via{" "}
            <a href="https://www.hpra.ie/" target="_blank">
              {" "}
              www.hpra.ie
            </a>
          </strong>
          <br />
          <br />
          <strong>Composition:</strong> Uzpruvo 45 mg: Each pre-filled syringe
          contains 45 mg ustekinumab in 0.5 mL. Uzpruvo 90 mg: Each pre-filled
          syringe contains 90 mg ustekinumab in 1 mL. Uzpruvo 130 mg: Each vial
          contains 130 mg ustekinumab in 26 mL (5 mg/mL). Excipients include
          histidine, polysorbate 80, sucrose, and water for injections. The
          pre-filled syringe components are latex free.{" "}
          <strong>Pharmaceutical Form:</strong> 45 mg and 90 mg: Subcutaneous
          injection (pre-filled glass syringe). 130 mg: Intravenous infusion
          (glass vial). <strong>Mechanism of Action:</strong> Ustekinumab is a
          fully human IgG1κ monoclonal antibody that targets the p40 subunit
          shared by interleukin (IL) 12 and IL-23. Indications: Uzpruvo 45 and
          90 mg is indicated for the treatment of plaque psoriasis, paediatric
          plaque psoriasis, psoriatic arthritis (PsA) adult Crohn's Disease and
          paediatric Crohn's Disease (patients ≥40 kg). Uzpruvo 130 mg is
          indicated for the treatment of adult Crohn's Disease and paediatric
          Crohn's Disease (patients ≥40 kg). <strong>Dosage:</strong> Uzpruvo is
          intended for use under the guidance and supervision of physicians
          experienced in the diagnosis and treatment of conditions for which
          Uzpruvo is indicated. Refer to Summary of Product Characteristics for
          information on dosing and administration.{" "}
          <strong>Method of administration:</strong> 45 and 90 mg: Subcutaneous
          injection;130 mg: Intravenous use. <strong>Contraindications:</strong>{" "}
          Hypersensitivity to the active substance or any excipients. Clinically
          important, active infections (e.g., active TB).{" "}
          <strong>Warnings and Precautions:</strong> Record product name and
          batch number of the administered product for traceability. Ustekinumab
          may increase the risk of infections and reactivate latent infections.
          Patients must be monitored for signs of infection before and during
          treatment. Tuberculosis screening required prior to treatment. Delay
          initiation in patients with active infection. Patients should be
          instructed to seek medical advice if signs or symptoms suggestive of
          an infection occur. Uzpruvo may increase the risk of malignancy. All
          patients, particularly those &gt;60 years of age, or with a history of
          prolonged immunosuppressant therapy or PUVA, should be monitored for
          skin cancer. Caution when transitioning from or co-administering with
          other immunosuppressants. Serious hypersensitivity reactions
          (including anaphylaxis, allergic alveolitis, eosinophilic pneumonia)
          have been reported. Regularly assess cardiovascular risk factors.
          Avoid live vaccines during and up to 15 weeks after treatment (e.g.
          BCG). In infants exposed in utero, defer live vaccines for 12 months
          after birth or until ustekinumab infant serum levels are undetectable.
          It is not known whether ustekinumab may affect allergy immunotherapy.
          In patients with psoriasis, exfoliative dermatitis has been reported
          following ustekinumab treatment. Monitor patients with psoriasis for
          symptoms of erythrodermic psoriasis or exfoliative dermatitis.
          Discontinue Uzpruvo if a drug reaction is suspected. Cases of
          lupus-related conditions have been reported in patients treated with
          Ustekinumab. Use caution in the elderly due to higher baseline
          infection risk. Uzpruvo contains polysorbates that may cause allergic
          reactions. <strong>Interactions:</strong> Live vaccines should not be
          given concurrently with Uzpruvo. The pharmacokinetics of ustekinumab
          was not impacted by concomitant use of MTX, NSAIDs, 6-mercaptopurine,
          azathioprine and oral corticosteroids in patients with PsA, Crohn's
          disease or ulcerative colitis, or prior exposure to anti-TNFα agents,
          in patients with PsA or Crohn's disease or by prior exposure to
          biologics in patients with ulcerative colitis. In psoriasis studies,
          the safety and efficacy of ustekinumab in combination with
          immunosuppressants, including biologics, or phototherapy have not been
          evaluated. In psoriatic arthritis studies, concomitant MTX use did not
          appear to influence the safety or efficacy of ustekinumab. In Crohn's
          disease and ulcerative colitis studies, concomitant use of
          immunosuppressants or corticosteroids did not appear to influence the
          safety or efficacy of Ustekinumab.{" "}
          <strong>Fertility, Pregnancy, and Lactation:</strong> Women of
          childbearing potential should use effective contraception during
          treatment and for at least 15 weeks after the last dose. Data from
          &gt;450 pregnancies indicate no increased risk of congenital
          malformations. Ustekinumab crosses the placenta and has been detected
          in infant serum. Infants may be at increased risk of infection. Live
          vaccines should be avoided for 12 months post-birth unless ustekinumab
          levels are undetectable. Ustekinumab is present in breast milk in low
          concentrations. Risk to breastfed infants is low, but breastfeeding
          decisions should balance risks and benefits. Effects on fertility have
          not been evaluated in humans.{" "}
          <strong>Driving and Machinery Use:</strong> Uzpruvo has no or
          negligible influence on the ability to drive and use machines.{" "}
          <strong>Undesirable Effects:</strong> Upper respiratory infections,
          nasopharyngitis, sinusitis, dizziness, headache, oropharyngeal pain,
          diarrhoea, nausea, vomiting, pruritus, back pain, myalgia, arthralgia,
          fatigue, injection site erythema and pain. Refer to SmPC for full
          adverse reaction list. <strong>Adverse Event Reporting:</strong>{" "}
          Adverse reactions should be reported via HPRA Pharmacovigilance,
          website: www.hpra.ie. <strong>Pack Sizes:</strong> 45 mg and 90 mg: 1
          pre-filled syringe. 130 mg: 1 vial. A copy of the Summary of Product
          Characteristics is available upon request or go to
          www.clonmelhealthcare.ie. <strong>MA Holder:</strong> STADA
          Arzneimittel AG, Stadastrasse 2-18, 61118 Bad Vilbel, Germany.
          EU/1/23/1784/001, 004, 005.{" "}
          <strong>Distributed in Ireland by:</strong> Clonmel Healthcare Ltd.,
          Waterford Road, Clonmel, Co. Tipperary. Medicinal product subject to
          restricted medical prescription.{" "}
          <strong>Date of Last Revision:</strong> April 2026.{" "}
          <strong>Date Prepared:</strong> June 2026 2606/ADV/UZP/602H
        </p>
      </InnerContainer>
    </Container>
  );
};

const Container = styled.section`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  @media screen and (min-width: 1024px) {
    grid-template-columns: repeat(12, 1fr);
  }
`;

const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  font-weight: 400;
  font-size: 0.625rem;
  grid-column: 1/7;
  padding: 3rem 1.25rem;
  gap: 1rem;
  h6 {
    color: var(--uzpruvo-purple);
    font-size: 0.625rem;
    font-weight: 700;
    text-transform: uppercase;
  }

  a {
    color: var(--uzpruvo-purple);
  }
  @media screen and (min-width: 1024px) {
    grid-column: 2/12;
    padding: 6rem 0;
  }
  @media screen and (min-width: 1600px) {
    grid-column: 3/11;
  }
`;

const FlexContainer = styled.div`
  display: flex;
  flex-direction: column-reverse;
  gap: 2rem;
  @media screen and (min-width: 1024px) {
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
  }
`;

export default DrugInformation;
